(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPrintRulesGroupList(
    $ngBootbox, toastr, $filter, GroupListService, GroupModel, PrintRulesService
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/printRules/groupList/groupList.template.html',
      link: function(scope) {

        scope.data = {};

        (function() {
          setGroupList();
        })();

        function setGroupList () {
          scope.groupList = [];
          const groups = scope.tenant.embedded[scope.context.groups];
          angular.forEach(groups, function (group) {
            const newGroup = new GroupModel(group);
            scope.groupList.push(newGroup);
          });
        }

        // LIST MENU
        scope.openListMenu = function (event, queue) {
          var position = document.getElementById(event.target.id).getBoundingClientRect();
          setTimeout(function () {
            scope.closeListMenu();
            scope.listMenuContext = queue;
            scope.listMeta = {
              position: {left: position.x, top: -300},
              parentId: event.target.id,
              type: 'nestedGroupList',
              scrollContainerId: 'GroupScrollContainer'
            }
            scope.$apply();
          }, 50)
        }

        scope.closeListMenu = function (group, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;

          switch (action) {
            case 'REMOVE_GROUP':
              scope.removeGroup(group);
            break;
          }
        }

        scope.removeGroup = function (group) {
          const isBlackWhiteGroups = scope.context.groups === 'blackWhiteGroups'
          var groupIDsRemove = [];
          groupIDsRemove.push(group.info._links.self.href.split('/groups/')[1]);

          var postObjectRemove = {
            type: 'DELETE',
            groups: groupIDsRemove
          }


          var postObjectWrapper = {}
          if (postObjectRemove.groups.length) {
            postObjectWrapper.delete = groupIDsRemove;
          }

          PrintRulesService.updatePrintRuleGroups(postObjectWrapper, isBlackWhiteGroups)
            .then(function(response) {
              toastr.success($filter("translate")("ChangesSaved"));
              scope.context.data = response;
              removeGroupFromList(group);
            }).catch(function(error) {
            toastr.error($filter("translate")("ERROR"));
          });

        }

        function removeGroupFromList (group) {
          for (var i = 0; i < scope.groupList.length; i++) {
            if (group.info._links.self.href === scope.groupList[i].info._links.self.href) {
              scope.groupList.splice(i, 1);
              break;
            }
          }
        }

        scope.addGroups = function (event) {
          scope.callback({context:
            {
              groups : scope.context.groups,
              link: scope.context.link,
              event: event,
              type: 'addPrintRulesGroups',
              bypassCloseOutside: true,
              dontUseTitle: false,
              dontUseName: true,
              exclude: scope.context.exclude,
              securityLevel: scope.context.securityLevel ?  scope.context.securityLevel : null,
              title: 'AddGroups',
              name: scope.context.name}});
        }

        scope.removeGroups = function (event) {
          scope.callback({context:
            {
              groups : scope.context.groups,
              link: scope.context.link,
              event: event,
              type: 'removePrintRulesGroups',
              dontUseTitle: false,
              dontUseName: true,
              securityLevel: scope.context.securityLevel ?  scope.context.securityLevel : null,
              title: 'RemoveGroups',
              name: scope.context.name}});
        }

      }
    };
  }

  pxPrintRulesGroupList.$inject = ['$ngBootbox', 'toastr', '$filter', 'GroupListService', 'GroupModel', 'PrintRulesService'];

  angular
    .module('printix-admin')
    .directive('pxPrintRulesGroupList', pxPrintRulesGroupList);

})();
